module.exports = "<div class=\"item user-block\" *ngIf=\"userBlockIsVisible()\">\r\n    <div class=\"user-block-info\"> \r\n        <span class=\"user-block-name\">{{ 'sidebar.WELCOME' | translate }},  {{user.name}}.</span>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./angularApp/app/layout/sidebar/userblock/userblock.component.html
// module id = 1252
// module chunks = 7